"use strict";

import ResponseView from "/js/interaction-views/response-view.js";
import Util from "/js/util/util.js";
import AppUtil from "/js/util/app-util.js";

/**
 * Base class for an "item"/step/question in an multi-step interaction
 * Manages a custom `ItemContentView` and a `ResponseView` (optional).
 * Is managed by a `MultiItemInteractionView`.
 * Used for binary-button, multiple-choice, plus.
 */
export default class ItemView {

  #$el = null;
   
  #contentView = null;
  #responseView = null;

  /**
   * @param questionObject The question object that comes from the lesson json
   * @param index The index of the item
   * @param numItems The total number of items
   * @param answerObject The previously-entered user answer (if any)
   */
  constructor(questionObject, index, numItems, answerObject=null) {

    this.#$el = $(`<div class="item-view"></div>`);

    this.#contentView = this.makeContentView(questionObject, index, numItems, answerObject);
    this.#$el.append(this.#contentView.$el);

    const hasResponse = questionObject.response && questionObject.response.type !== "none";
    if (hasResponse) {
      this.#responseView = new ResponseView(questionObject.response);
      this.#$el.append(this.#responseView.$el);
    }
    this.#$el.on("content-view", $.proxy(this.#onContentViewDone, this));
    this.#$el.on("response-view", $.proxy(this.#onResponseViewDone, this));
  }

  /** 
   * This is the only thing the subclass must override. 
   */
  makeContentView(questionObject, index, numItems) { 
    throw new Error("Subclass must override this function.")
  }

  get $el() {
    return this.#$el;
  }

  /** Is called when ItemView has been shown. */
  onShow() {
    this.#contentView.onShow();
  }

  /*
   * Is called when user has "finished" the associated content view (eg, by selecting a button).
   */
  #onContentViewDone(e, payload) {

    e.stopPropagation();
    
    if (!this.#responseView) {

      this.#$el.trigger("item-done", payload);

    } else {

      AppUtil.animOutToTop(this.#contentView.$el);

      this.#responseView.populate(payload);
      AppUtil.animInFromBottom(this.#responseView.$el, null,
          () => Util.flashMacScrollbar(this.#responseView.$content));
    }
  }

  /* 
   * Is called when user clicks "continue" in the response view.
   */
  #onResponseViewDone(e) {
    e.stopPropagation();
    this.#$el.trigger("item-done", null);
  }
}
